import { SalesOrdersViewHeaderButtons } from './sales-orders-view-header-buttons'

export interface ISalesOrdersViewHeaderOptions {
  showPrintSelected: true
}

export { SalesOrdersViewHeaderButtons }
